import { Injectable, inject } from '@angular/core';
import {
  IActualizacionFirmware,
  ICrearActualizacionFirmware,
  IListado,
  IQueryParam,
} from 'modelos/src';
import { Observable } from 'rxjs';
import { HelperService } from '../../auxiliares/servicios/helper.service';
import { HttpApiAdminService } from '../../auxiliares/servicios/http-api.service';

@Injectable({
  providedIn: 'root',
})
export class ActualizarFirmwareService {
  private http = inject(HttpApiAdminService);
  private helper = inject(HelperService);

  public listar(
    queryParams?: IQueryParam,
  ): Observable<IListado<IActualizacionFirmware>> {
    let params = this.helper.getQueryParams(queryParams);
    return this.http.get(`/actualizacionfirmwares`, { params });
  }

  public listarPorId(id: string): Observable<IActualizacionFirmware> {
    return this.http.get(`/actualizacionfirmwares/${id}`);
  }

  public crear(
    dato: ICrearActualizacionFirmware,
  ): Observable<IActualizacionFirmware> {
    return this.http.post(`/actualizacionfirmwares`, dato);
  }
}
